// PequeMimo — scripts propios (mt-)
(function () {
  'use strict';

  if (window.__mtScriptsInit) return;
  window.__mtScriptsInit = true;

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal, .mt-reveal-scale');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el, i) {
      if (!el.style.transitionDelay) {
        el.style.transitionDelay = Math.min(i % 4, 3) * 90 + 'ms';
      }
      observer.observe(el);
    });
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-mt-contador]');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animar = function (el) {
      var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
      if (reduce) { el.textContent = fin; return; }
      var inicio = 0;
      var duracion = 1200;
      var t0 = null;
      function paso(ts) {
        if (!t0) t0 = ts;
        var progreso = Math.min((ts - t0) / duracion, 1);
        var valor = Math.floor(inicio + (fin - inicio) * (1 - Math.pow(1 - progreso, 3)));
        el.textContent = valor;
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin;
      }
      requestAnimationFrame(paso);
    };
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animar(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { observer.observe(el); });
  }

  function initFaq() {
    var grupos = document.querySelectorAll('[data-mt-faq]');
    grupos.forEach(function (grupo) {
      var items = grupo.querySelectorAll('[data-mt-faq-item]');
      items.forEach(function (item) {
        var pregunta = item.querySelector('[data-mt-faq-pregunta]');
        if (!pregunta) return;
        pregunta.addEventListener('click', function () {
          var abierto = item.classList.contains('mt-faq-abierto');
          items.forEach(function (i) { i.classList.remove('mt-faq-abierto'); });
          if (!abierto) item.classList.add('mt-faq-abierto');
        });
      });
    });
  }

  function initVariantes() {
    var forms = document.querySelectorAll('[data-mt-producto-form]');
    forms.forEach(function (form) {
      var dataEl = form.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var contenedorProducto = form.closest('[data-mt-producto]');
      var selectores = form.querySelectorAll('[data-mt-opcion]');
      var idInput = form.querySelector('input[name="id"]');
      var precioEl = contenedorProducto ? contenedorProducto.querySelector('[data-mt-precio]') : null;
      var precioComparadoEl = contenedorProducto ? contenedorProducto.querySelector('[data-mt-precio-comparado]') : null;
      var botonEl = form.querySelector('[data-mt-add-boton]');
      var botonTextoBase = botonEl ? botonEl.getAttribute('data-mt-texto-base') : '';
      var botonTextoAgotado = botonEl ? botonEl.getAttribute('data-mt-texto-agotado') : '';

      function opcionesSeleccionadas() {
        var vals = {};
        selectores.forEach(function (sel) {
          var nombre = sel.getAttribute('data-opcion-nombre');
          var activo = sel.querySelector('.mt-opcion-activa');
          if (nombre) vals[nombre] = activo ? activo.getAttribute('data-valor') : null;
        });
        return vals;
      }

      function encontrarVariante() {
        var vals = opcionesSeleccionadas();
        var nombres = Object.keys(vals);
        return variantes.find(function (v) {
          return nombres.every(function (nombre) { return v.options_by_name[nombre] === vals[nombre]; });
        });
      }

      function actualizar() {
        var variante = encontrarVariante();
        if (!variante) return;
        if (idInput) idInput.value = variante.id;
        if (precioEl) precioEl.textContent = variante.price_formatted;
        if (precioComparadoEl) {
          if (variante.compare_at_price_formatted) {
            precioComparadoEl.textContent = variante.compare_at_price_formatted;
            precioComparadoEl.style.display = '';
          } else {
            precioComparadoEl.style.display = 'none';
          }
        }
        if (botonEl) {
          if (variante.available) {
            botonEl.disabled = false;
            botonEl.textContent = botonTextoBase;
          } else {
            botonEl.disabled = true;
            botonEl.textContent = botonTextoAgotado;
          }
        }
        form.querySelectorAll('[data-mt-imagen-variante]').forEach(function (img) {
          img.style.display = 'none';
        });
        if (variante.featured_image_id && contenedorProducto) {
          var img = contenedorProducto.querySelector(
            '[data-mt-miniatura][data-media-id="' + variante.featured_image_id + '"]'
          );
          if (img) img.click();
        }
      }

      selectores.forEach(function (grupo) {
        grupo.querySelectorAll('[data-valor]').forEach(function (opt) {
          opt.addEventListener('click', function () {
            grupo.querySelectorAll('[data-valor]').forEach(function (o) { o.classList.remove('mt-opcion-activa'); });
            opt.classList.add('mt-opcion-activa');
            actualizar();
          });
        });
      });

      actualizar();
    });
  }

  function initPacks() {
    document.querySelectorAll('[data-mt-packs]').forEach(function (contenedor) {
      var tarjetas = contenedor.querySelectorAll('[data-mt-pack]');
      var contenedorProducto = contenedor.closest('[data-mt-producto]');
      if (!contenedorProducto) return;
      var cantidadInput = contenedorProducto.querySelector('[data-mt-cantidad]');
      var resumenTotal = contenedorProducto.querySelector('[data-mt-packs-resumen-total]');
      var resumenEnvio = contenedorProducto.querySelector('[data-mt-packs-resumen-envio]');
      var individualGrupo = contenedorProducto.querySelector('[data-mt-opcion-individual]');
      var packColoresWrap = contenedorProducto.querySelector('[data-mt-pack-colores]');
      var dataEl = contenedorProducto.querySelector('[data-mt-variantes-json]');
      var form = contenedorProducto.querySelector('[data-mt-producto-form] form');
      var boton = contenedorProducto.querySelector('[data-mt-add-boton]');

      var variantes = [];
      if (dataEl) {
        try { variantes = JSON.parse(dataEl.textContent); } catch (e) { variantes = []; }
      }
      var colorOptionName = variantes.length ? variantes[0].color_option_name : null;
      var excluidosTexto = packColoresWrap ? (packColoresWrap.getAttribute('data-mt-pack-excluir') || '') : '';
      var excluidos = excluidosTexto.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var colores = [];
      variantes.forEach(function (v) {
        var valor = colorOptionName ? v.options_by_name[colorOptionName] : null;
        if (valor && excluidos.indexOf(valor) === -1 && colores.indexOf(valor) === -1) colores.push(valor);
      });

      function wireSlotBotones(scope) {
        scope.querySelectorAll('.mt-opcion-valor').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var hermanos = btn.closest('.mt-opcion-valores');
            hermanos.querySelectorAll('.mt-opcion-valor').forEach(function (b) { b.classList.remove('mt-opcion-activa'); });
            btn.classList.add('mt-opcion-activa');
          });
        });
      }

      function renderSlots(cantidad) {
        if (!packColoresWrap || !colores.length) return;
        var titulo = packColoresWrap.querySelector('.mt-pack-colores-titulo');
        packColoresWrap.querySelectorAll('.mt-pack-slot').forEach(function (el) { el.remove(); });
        for (var i = 0; i < cantidad; i++) {
          var colorDefecto = colores[i % colores.length];
          var fila = document.createElement('div');
          fila.className = 'mt-pack-slot';

          var label = document.createElement('p');
          label.className = 'mt-pack-slot-label';
          label.textContent = (contenedorProducto.getAttribute('data-mt-unidad-texto') || 'Unidad') + ' ' + (i + 1);
          fila.appendChild(label);

          var valoresWrap = document.createElement('div');
          valoresWrap.className = 'mt-opcion-valores';
          colores.forEach(function (color) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'mt-opcion-valor' + (color === colorDefecto ? ' mt-opcion-activa' : '');
            btn.setAttribute('data-valor', color);
            btn.textContent = color;
            valoresWrap.appendChild(btn);
          });
          fila.appendChild(valoresWrap);
          packColoresWrap.appendChild(fila);
        }
        wireSlotBotones(packColoresWrap);
      }

      // Los slots ya vienen pintados desde el servidor si el pack activo al cargar tiene más de 1 unidad;
      // solo hace falta conectar los clics de esos botones iniciales.
      if (packColoresWrap) wireSlotBotones(packColoresWrap);

      tarjetas.forEach(function (tarjeta) {
        tarjeta.addEventListener('click', function () {
          tarjetas.forEach(function (t) { t.classList.remove('mt-pack-activo'); });
          tarjeta.classList.add('mt-pack-activo');
          var cantidad = parseInt(tarjeta.getAttribute('data-cantidad'), 10) || 1;
          if (cantidadInput) cantidadInput.value = cantidad;
          if (resumenTotal) resumenTotal.textContent = tarjeta.getAttribute('data-total') || '';
          if (resumenEnvio) resumenEnvio.textContent = tarjeta.getAttribute('data-envio') || '';

          if (cantidad > 1) {
            if (individualGrupo) individualGrupo.hidden = true;
            if (packColoresWrap) packColoresWrap.hidden = false;
            renderSlots(cantidad);
          } else {
            if (individualGrupo) individualGrupo.hidden = false;
            if (packColoresWrap) packColoresWrap.hidden = true;
          }
        });
      });

      if (form) {
        form.addEventListener('submit', function (e) {
          var cantidad = cantidadInput ? parseInt(cantidadInput.value, 10) || 1 : 1;
          if (cantidad <= 1 || !packColoresWrap) return;

          e.preventDefault();
          var items = [];
          packColoresWrap.querySelectorAll('.mt-pack-slot').forEach(function (slot) {
            var activo = slot.querySelector('.mt-opcion-activa');
            var color = activo ? activo.getAttribute('data-valor') : colores[0];
            var variante = variantes.find(function (v) { return colorOptionName && v.options_by_name[colorOptionName] === color; });
            if (variante) items.push({ id: variante.id, quantity: 1 });
          });
          if (!items.length) return;

          var textoOriginal = boton ? boton.textContent : '';
          if (boton) { boton.disabled = true; boton.textContent = 'Añadiendo...'; }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            .then(function () { window.location.href = '/cart'; })
            .catch(function () {
              if (boton) { boton.disabled = false; boton.textContent = textoOriginal; }
              alert('No se pudo añadir el pack al carrito. Inténtalo de nuevo.');
            });
        });
      }
    });
  }

  function initGaleria() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (contenedor) {
      var principal = contenedor.querySelector('[data-mt-imagen-principal]');
      var miniaturas = contenedor.querySelectorAll('[data-mt-miniatura]');
      if (!principal || !miniaturas.length) return;
      miniaturas.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-full');
          if (src) principal.setAttribute('src', src);
          miniaturas.forEach(function (m) { m.classList.remove('mt-miniatura-activa'); });
          mini.classList.add('mt-miniatura-activa');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initContadores();
    initFaq();
    initVariantes();
    initPacks();
    initGaleria();
  });
})();
